<!--
 * @Author: zhouhx
 * @Date: 2022-06-20 10:55:24
 * @LastEditors: zhouhx
 * @LastEditTime: 2022-08-26 14:39:14
 * @Description:
-->
<template>
  <div class="weblink">
    <van-nav-bar :title="weblink_data.name" left-arrow @click-left="backDetail()">
      <template #left></template>
      <template #right>
        <div></div>
      </template>
    </van-nav-bar>
    <div id="content_div" class="content_div">
      <iframe :src="weblink_data.url" frameborder="0"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      // 存储url数据
      weblink_data: {}
    };
  },
  created () {
    this.weblink_data = JSON.parse(window.localStorage.getItem('weblink_data'));
  },
  methods: {
    backDetail () {
      this.$router.back();
    },
    // 释放缓存
    beforeDestroy () {
      localStorage.removeItem('weblink_data');
    }
  },
  components: {}
};
</script>
<style lang="scss" scoped>
.weblink {
  overflow: hidden;
  height: 100%;
  position: absolute;
  width: 100%;
  padding: 0;
  left: 0;
  bottom: 0;
  .content_div {
    iframe {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
